export const categories = [
  { slug: 'love', name: '恋爱漫画', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画，心动故事一网打尽' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line', description: '激烈打斗与热血剧情，让你肾上腺素飙升' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', description: '穿越异世界，探索神秘奇幻的漫画世界' },
  { slug: 'horror', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '扣人心弦的悬疑故事，挑战你的胆量极限' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', description: '轻松幽默的日常故事，笑到停不下来' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', description: '现实向都市题材，职场与人生百态' },
  { slug: 'school', name: '校园青春', icon: 'ri-book-open-line', description: '青春校园故事，回忆最美好的学生时代' },
  { slug: 'historical', name: '古风历史', icon: 'ri-history-line', description: '穿越古今的史诗故事，王朝兴衰与爱恨情仇' },
];